export const TRACE_PROPAGATION_TARGETS: RegExp[] = [
  /^https?:\/\/localhost(?::\d+)?\//,
  /\.zonedlabs\.com\//,
  /\.zonedlabs\.ai\//,
  /^https?:\/\/(?:[\w-]+\.)+golfrecruit\.ai\//,
  /^\//,
];
